module.exports = __webpack_public_path__ + "img/bg-right.28a3ac86.png";